import React from 'react';
import {Route} from 'react-router-dom';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';

export default [
  <Route
    key="/business/showcase/3d-viewer/home"
    element={<ShowocaseLayout />}
  >
    <Route path="business/showcase/3d-viewer/home" element={<AsyncPage />} />
  </Route>,
];
